import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';


export default (calendarElement) => {

    return new Calendar(calendarElement, {
        plugins: [ dayGridPlugin ],
        defaultView: 'dayGridMonth',
        height: 'auto',
        events: window.fullCalendarInstances || [],
        firstDay: 1,
    });


}



// WEBPACK FOOTER //
// ./src/js/calendar.js